var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00FF51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.786 8H9.21C8.543 8 8 8.55 8 9.226v14.548A1.22 1.22 0 0 0 9.21 25h14.576c.668 0 1.214-.55 1.214-1.226V9.226C25 8.55 24.454 8 23.786 8ZM13.138 22.571h-2.52v-8.113h2.524v8.113h-.004Zm-1.26-9.22a1.462 1.462 0 0 1 0-2.922c.805 0 1.461.656 1.461 1.46a1.46 1.46 0 0 1-1.46 1.461Zm10.705 9.22h-2.52v-3.946c0-.941-.019-2.152-1.309-2.152-1.313 0-1.514 1.025-1.514 2.084v4.014h-2.52v-8.113h2.417v1.108h.035c.337-.637 1.16-1.309 2.386-1.309 2.55 0 3.025 1.681 3.025 3.867v4.447Z",
    fill: "#000"
  })));
};

export default SvgSocialLinkedin;